module.exports = __webpack_public_path__ + "img/menu-icon-faq-circle.777dd211.svg";